import React, { useMemo } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useUIConfig } from '../utils/uiConfigHelper';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const uiConfig = useUIConfig();
  
  const theme = useMemo(() => {
    // Default theme fallback if no uiConfig is available
    if (!uiConfig || !uiConfig.config || !uiConfig.config.palette) {
      return createTheme({
        // Default theme settings
        palette: {
          primary: {
            main: '#8737E1',
            light: '#5F5F5F',
            contrastText: 'white'
          },
          secondary: {
            main: '#7C29DD',
            light: '#A5A5A5',
            dark: '#323232',
            contrastText: 'white'
          }
        },
        typography: {
          fontFamily: "'graphik', sans-serif"
        }
      });
    }
    
    // Create theme using uiConfig.config.palette
    return createTheme({
      palette: {
        primary: {
          main: uiConfig.config.palette.primary.main,
          light: uiConfig.config.palette.primary.light,
          contrastText: uiConfig.config.palette.primary.contrastText
        },
        secondary: {
          main: uiConfig.config.palette.secondary.main,
          light: uiConfig.config.palette.secondary.light,
          dark: uiConfig.config.palette.secondary.dark,
          contrastText: uiConfig.config.palette.secondary.contrastText
        },
        text: {
          primary: uiConfig.config.palette.text.primary,
          secondary: uiConfig.config.palette.text.secondary
        },
        error: {
          main: uiConfig.config.palette.error.main
        }
      },
      typography: {
        fontFamily: uiConfig.config.typography?.fontFamily || '"Roboto", "Helvetica", "Arial", sans-serif'
      }
    });
  }, [uiConfig]);

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
